import React from "react";
import { Datagrid, EditButton, FunctionField, NumberField, SimpleList } from "react-admin";
import { useMediaQuery } from "@mui/material";
import ScholarshipBudgetExpanded from "./ScholarshipBudgetExpanded";
import ScholarshipBudgetMobileExpanded from "./ScholarshipBudgetMobileExpanded";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import { Currency, MOBILE_BREAKPOINT } from "utils/constants";
import { settings } from "app";
import { tenants } from "utils/tenants";
import { MobileListRow } from "features/MobileListRow";

const ScholarshipBudgetTable = () => {
  const isMgu = settings.tenant === tenants.MGU;
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  if (isMobile) {
    return (
      <SimpleList
        linkType={false}
        sx={settings.style.mobileList}
        primaryText={record => (
          <MobileListRow fields={[{ label: "Календарна година", value: record?.fiscalYear }]} />
        )}
        secondaryText={record => {
          return (
            <>
              <div>
                <MobileListRow
                  fields={[
                    {
                      label: "Сума",
                      value: (
                        <NumberField
                          source="amount"
                          emptyText="-"
                          options={{ style: "currency", currency: Currency.EUR }}
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Изразходвана сума",
                      value: (
                        <NumberField
                          source="spentAmount"
                          emptyText="-"
                          options={{ style: "currency", currency: Currency.EUR }}
                        />
                      ),
                    },
                  ]}
                />
                <MobileListRow
                  fields={[
                    {
                      label: "Неразпределен бюджет",
                      value: (
                        <NumberField
                          source="unallocatedAmount"
                          emptyText="-"
                          options={{ style: "currency", currency: Currency.EUR }}
                        />
                      ),
                    },
                  ]}
                />
              </div>
              <ScholarshipBudgetMobileExpanded record={record} />
            </>
          );
        }}
        tertiaryText={record =>
          record?.isUniversityWide && (
            <SecuredComponent permission={permissions.canUpdateScholarshipBudgets}>
              <EditButton label="" />
            </SecuredComponent>
          )
        }
      />
    );
  }

  return (
    <Datagrid
      bulkActionButtons={false}
      rowClick={false}
      expand={<ScholarshipBudgetExpanded />}
      expandSingle
      isRowExpandable={() => !isMgu}
      sx={{
        "& .RaDatagrid-headerCell": {
          textAlign: "left",
        },
      }}
    >
      <NumberField
        source="fiscalYear"
        label="Календарна година"
        options={{ useGrouping: false }}
        textAlign="left"
      />
      <NumberField
        source="amount"
        label="Сума"
        emptyText="-"
        options={{ style: "currency", currency: Currency.EUR }}
        textAlign="left"
      />

      <NumberField
        source="spentAmount"
        label="Изразходвана сума"
        emptyText="-"
        options={{ style: "currency", currency: Currency.EUR }}
        textAlign="left"
      />
      <NumberField
        source="unallocatedAmount"
        label="Неразпределен бюджет"
        emptyText="-"
        options={{ style: "currency", currency: Currency.EUR }}
        textAlign="left"
      />

      <FunctionField
        render={record =>
          record?.isUniversityWide && (
            <SecuredComponent permission={permissions.canUpdateScholarshipBudgets}>
              <EditButton />
            </SecuredComponent>
          )
        }
      />
    </Datagrid>
  );
};

export default ScholarshipBudgetTable;
